import { render, staticRenderFns } from "./ReadingRoom2.vue?vue&type=template&id=80c40a16&"
import script from "./ReadingRoom2.vue?vue&type=script&lang=js&"
export * from "./ReadingRoom2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VCard,VCardText,VContainer,VDatePicker})
